import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { setPageTitle } from '../../utils/title';
import Breadcrumb from '../../components/Breadcrumb';

const Products = () => {
  useEffect(() => {
    setPageTitle('Products');
  }, []);

  return (
    <>
      <Breadcrumb
        items={[
          { label: 'Home', path: '/' },
          { label: 'Products', path: '/products' },
        ]}
      />
      <section className="page-header">
        <div className="container">
          <h1 className="page-header__title">Products</h1>
          <p className="page-header__subtitle">We are building and deploying our products to AWS</p>
        </div>
      </section>
      <section className="section section--light">
        <div className="container">
          <div className="row">
            <div className="col col-md-6">
              <div className="card">
                <h3 className="card__title">
                  <Link to="/products/photo-kiosk-backend">Photo Kiosk Backend</Link>
                </h3>
                <p className="card__description">
                  For photo kiosk owners seeking a robust backend, our solution deploys directly to
                  your AWS account in just 15 minutes. It manages photo uploads, QR code generation,
                  media expiration, and features a fully customizable download page to showcase your
                  brand. Enjoy a cost-effective, feature-rich backend to power your photo kiosk.
                </p>
              </div>
            </div>
            <div className="col col-md-6">
              <div className="card">
                <h3 className="card__title">
                  <Link to="/products/bookstack-wiki">Bookstack Wiki</Link>
                </h3>
                <p className="card__description">
                  An AWS-deployed version of BookStack, the open-source wiki platform ({' '}
                  <a href="https://www.bookstackapp.com/" target="_blank" rel="noopener noreferrer">
                    bookstackapp.com
                  </a>{' '}
                  ). Instantly launch your corporate wiki on AWS, with optional Google
                  authentication for streamlined, centralized user management.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Products;

export { default as PhotoKioskFulfillment } from './photo-kiosk-backend-fulfillment';
export { default as PhotoKioskBackend } from './photo-kiosk-backend';
